<template>
  <div>
    <HeaderSteps
      :title="`${currentStep === -1 ? 'Impersonate' : 'New campaign'}`"
      :steps="type === 'simple' ? steps : []"
      :active="currentStep"
      :formDataValidate="formDataValidate"
      :back-path="-1"
      @step="handlerStep"
    >
    </HeaderSteps>
    <template v-if="currentStep === -1">
      <ImpersonateForm />
    </template>
    <template v-if="currentStep === 0">
      <CampaignDetails :type="type" @step="getCurrentStep" @change="onChange" @validateForm="validateForm" ref="formDetails" />
    </template>
    <template v-if="currentStep === 1">
      <CampaignPeriod @step="getCurrentStep" @validateForm="validateForm" @change="onChange" ref="formPeriod" />
    </template>
    <template v-if="currentStep === 2">
      <Assets @validateForm="validateForm" />
    </template>
  </div>
</template>
<script>
import HeaderSteps from '@/components/social-products/social-boost/parts/HeaderSteps.vue'
import CampaignDetails from '@/components/social-products/social-boost/forms/CampaignDetails.vue'
import CampaignPeriod from '@/components/social-products/social-boost/forms/PeriodBudget.vue'
import Assets from '@/components/social-products/social-boost/forms/Assets.vue'
import SocialBoostCampaignMixin from '@/mixins/social-products/social-boost-campaign'
import SocialBoostCampaignAutosaveMixin from '@/mixins/social-products/CampaignAutosave'
import ImpersonateForm from '@/components/social-products/social-boost/forms/ImpersonateForm.vue'

export default {
  name: 'CreateCampaign',
  mixins: [SocialBoostCampaignMixin, SocialBoostCampaignAutosaveMixin],
  components: {
    HeaderSteps,
    CampaignDetails,
    CampaignPeriod,
    Assets,
    ImpersonateForm,
  },
  data() {
    return {
      steps: ['Campaign details', 'Period and budget', 'Assets'],
      currentStep: 0,
      formDataValidate: false,
    }
  },
  async created() {
    this.currentStep = this.$is_PM ? -1 : this.$route?.query?.step ? Number(this.$route.query.step) : 0
    if (this.$route?.query.campaign) {
      await this.updateStoreFormDetails(true)
    }
  },
  computed: {
    type() {
      return this.$route.params.type
    },
  },
  methods: {
    getCurrentStep(step) {
      this.currentStep = step
    },
    handlerStep(step) {
      this.currentStep = step
    },
    validateForm(validate) {
      this.formDataValidate = validate
    },
  },
}
</script>
